import { selectSelectedBusinessVerifier } from '@store/business/BusinessVerifierReducer'
import { useAppSelector } from '@store/hooks'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { matchValueRule, minLengthRule } from '@utils/rules'
import { Alert, Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedBusinessVerifier())
  const password = Form.useWatch('password', form)

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Alert
        type="info"
        title="You can update the username or the password independently."
        style={{ marginBottom: 16 }}
      />
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="username" rules={[minLengthRule(6)]} label={'Username'}>
        <Input />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[minLengthRule(6)]}
        label={'New password'}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        rules={[matchValueRule(password), minLengthRule(6)]}
        label={'Confirm new password'}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item name="venue" hidden>
        <SBAsyncSelect entity={Entity.venue} />
      </Form.Item>
    </Form>
  )
}

export default Update
